import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ConfigurationService } from 'mbs-ui-shared/src/lib/services/configuration.service';
import { RoutingPath } from 'mbs-ui-shared@constants';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { OneTimeAuthToken } from 'mbs-ui-shared@models/one-time-token.model';
import { AuthService } from 'mbs-ui-shared@services/auth/auth.service';
import { of } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';

export const supportPortalGuard = (currentRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authFacade = inject(AuthFacade);
  const authService = inject(AuthService);
  const config = inject(ConfigurationService);
  const router = inject(Router);
  const urlCandidate = new URL(state.url || location.href, location.origin);

  return authFacade.currentUser$.pipe(
    first(),
    switchMap((res) => {
      const loginAs = currentRoute.queryParams?.['login_as'] || urlCandidate.searchParams.get('login_as');
      const force = currentRoute.queryParams?.force || urlCandidate.searchParams.get('force');

      const isSameUser = res?.Email === loginAs || force;

      return isSameUser ? authFacade.oneTimeAuthTokenRequest$() : of('needToReLogin');
    }),
    map((res) => {
      if (!res || !config.get('supportUrl')) {
        return router.parseUrl(RoutingPath.ApNotFound);
      }

      const currentPath = urlCandidate.pathname;
      const additionalPath = currentPath.includes(RoutingPath.SupportPortal) ? currentPath.split(RoutingPath.SupportPortal)[1] : '';

      if (res === 'needToReLogin') {
        window.location.href = `${RoutingPath.Login}${location.search}&logoff=1`;
      } else {
        window.location.href = authService.getSupportPortalUrl(res as OneTimeAuthToken, additionalPath);
      }

      return false;
    })
  );
};
